import ComponentError from 'components/Error/ComponentError';
import FeaturedOfferingCard from 'components/FeaturedOfferingCard';
import useMobxStores from 'hooks/useMobxStores';
import { observer } from 'mobx-react';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { handleError } from 'services/ErrorService';

const LastAccessedOffering = () => {
  const { t } = useTranslation();
  const { progressStore } = useMobxStores();
  const { lastAccessedOffering } = progressStore;
  return (
    <section className="my-activity__lane-element">
      <div className="my-activity__lane-title">
        <h3>{t('My activity')}</h3>
      </div>
      <FeaturedOfferingCard
        className="my-activity__lane-card"
        isLoading={progressStore.isLoadingLastAccessed}
        entry={lastAccessedOffering.entry}
        deliveryFormat={lastAccessedOffering.deliveryFormat}
        total_progress={lastAccessedOffering.progress?.total_progress}
        data-analytics-id="continue-featured-card-my-activity-lp"
      />
    </section>
  );
};

export default withErrorBoundary(
  observer(LastAccessedOffering),
  ComponentError,
  handleError,
);
